// src/components/Logo.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isRtlLang } from '../i18n';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  withText?: boolean;
}

const Logo: React.FC<LogoProps> = ({
  size = 'md',
  className = '',
  withText = true,
}) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
  };

  const logoPath = `/assets/logo.png`;

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={logoPath}
        alt="oneseventeen logo"
        className={`${sizeClasses[size]} object-contain`}
      />
      {withText && (
        <div className={isRtlLang(currentLanguage) ? 'mr-3' : 'ml-3'}>
          <span className="text-white font-bold text-xl block">
            {t('header.logoTitle')}
          </span>
          <span className="text-gray-300 text-xs block">
            {t('header.logoText')}
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
